import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  TBillingStatus,
  TCheckoutSession,
  TFailedBalance,
  TFinalizeWalkthroughResult,
  TMembershipSummary,
} from './payments.types.ts';

export const paymentsApi = {
  getMembershipSummary: async () => {
    const response = await axios.get<TMembershipSummary>(`payments/membership-summary`);

    return response.data;
  },
  getBillingStatus: async () => {
    const response = await axios.get<TBillingStatus>(`payments/billing-status`);

    return response.data;
  },
  createWalkthroughDepositCheckout: async () => {
    const response = await axios.post<TCheckoutSession>(
      `payments/walkthrough-deposit-checkout-session`,
    );

    return response.data;
  },
  createWalkthroughBalanceCheckout: async () => {
    const response = await axios.post<TCheckoutSession>(
      `payments/walkthrough-balance-checkout-session`,
    );

    return response.data;
  },
  // Admin
  getFailedBalances: async () => {
    const response = await axios.get<TFailedBalance[]>(`payments/admin/failed-balances`);

    return response.data;
  },
  retryBalance: async (userId: number) => {
    const response = await axios.post<TFinalizeWalkthroughResult>(
      `payments/admin/clients/${userId}/retry-balance`,
    );

    return response.data;
  },
};

export const paymentsQueries = createQueryKeys('payments', {
  getMembershipSummary: () => ({
    queryKey: ['membership-summary'],
    queryFn: paymentsApi.getMembershipSummary,
  }),
  getBillingStatus: () => ({
    queryKey: ['billing-status'],
    queryFn: paymentsApi.getBillingStatus,
  }),
  getFailedBalances: () => ({
    queryKey: ['failed-balances'],
    queryFn: paymentsApi.getFailedBalances,
  }),
});
